export const LEGACY_DOC_UNSUPPORTED_MESSAGE = "Legacy .doc files are not supported for Drafting DNA in v1.0. Please convert the file to .docx or PDF and upload it again.";
export const UPLOAD_IN_PROGRESS_MESSAGE = "A Drafting DNA upload is already in progress. Please wait for the current batch to finish.";

export const isLegacyDocFile = (fileName = "") => fileName.toLowerCase().endsWith('.doc');

export const buildUploadFileKey = (file) => [file?.name || '', file?.size || 0, file?.lastModified || 0].join('::');

export const dedupeUploadFiles = (files = []) => {
  const seen = new Set();
  return files.filter((file) => {
    const key = buildUploadFileKey(file);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export const beginUploadBatch = (uploadLockRef) => {
  if (uploadLockRef.current) {
    return false;
  }
  uploadLockRef.current = true;
  return true;
};

export const finishUploadBatch = (uploadLockRef) => {
  uploadLockRef.current = false;
};

export const uploadDraftingDnaSamplesSequentially = async ({ files = [], uploadFile }) => {
  const uniqueFiles = dedupeUploadFiles(files);
  const results = [];

  for (const file of uniqueFiles) {
    try {
      await uploadFile(file);
      results.push({ fileName: file.name, success: true });
    } catch (error) {
      results.push({
        fileName: file.name,
        success: false,
        error,
      });
    }
  }

  return results;
};